export enum MobileMenuTypesEnum {
  side = 'side',
  dropDown = 'dropDown',
}
